// extracted by mini-css-extract-plugin
export default {"container":"uq-z","brandName":"vq-z","productName":"wq-z","productNamePdpEnhancements":"xq-z","breakLongProductName":"yq-z"};